// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 990px) {
  .container-datepicker {
    float: left;
    width: 100%;
    margin: -75px 7.5px 15px 7.5px;
  }
  .container-datepicker app-datepicker {
    margin: 20px 0 20px 0;
    float: right;
  }
}
@media only screen and (max-width: 991px) {
  .container-datepicker {
    float: left;
    width: 100%;
    margin: 15px 7.5px 15px 7.5px;
  }
  .container-datepicker app-datepicker {
    margin: 20px 0 20px 0;
    float: right;
  }
}
@media only screen and (max-width: 515px) {
  .container-datepicker {
    margin: 0;
    padding: 0 7.5px;
  }
  app-datepicker {
    width: 100%;
  }
  .btn-primary {
    width: 100%;
  }
}
table {
  margin: 0;
}

app-datepicker {
  float: right;
  margin-right: calc(8.333333% + 15px);
}

.hidden {
  opacity: 0;
}

.container-loading {
  width: 35px;
  height: 35px;
  margin: 0 auto;
}
.container-loading .loading {
  margin: 100px 0 0 0;
}

.error {
  width: 100%;
  font-size: 16px;
  font-weight: 100;
  color: #999999;
  text-align: center;
  display: inline-block;
}
.error:first-child {
  margin-top: 100px;
}

.caixa-pesquisa {
  cursor: text;
}
.caixa-pesquisa div input {
  position: absolute;
  left: 55px;
  width: 300px;
  max-width: calc(100% - 75px);
  outline: none;
  border: 0px;
  height: 40px;
}
.caixa-pesquisa input.search {
  position: relative;
  border-radius: 6px;
  height: 40px;
  width: 100%;
  margin: 0 0 20px 0;
  border: none;
  padding: 5px 50px;
  outline: none;
  transition: border-color 0.5s ease;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);
}
.caixa-pesquisa input.search:active, .caixa-pesquisa input.search:hover, .caixa-pesquisa input.search:focus {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
}
.caixa-pesquisa::after, .caixa-pesquisa::before {
  content: " ";
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 24px;
  top: 8px;
}
.caixa-pesquisa::before {
  left: 20px;
  background-image: url("/assets/img/icons/pesquisa.svg");
}
.caixa-pesquisa::after {
  right: 20px;
  cursor: pointer;
  background-image: url("/assets/img/icons/filtro.svg");
}
.caixa-pesquisa .filter-icon {
  position: absolute;
  top: 0;
  right: 12px;
  height: 40px;
  width: 40px;
  cursor: pointer;
  z-index: 5;
}
.caixa-pesquisa .box-filter {
  z-index: 5;
  position: absolute;
  width: 250px;
  top: 0;
  right: -245px;
  background-color: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);
  overflow: hidden;
}
.caixa-pesquisa .box-filter.box-hidden {
  transition: 0.4s;
  opacity: 0;
  z-index: -1;
}
.caixa-pesquisa .box-filter.box-show {
  transition: 0.4s;
  opacity: 1;
}
.caixa-pesquisa .box-filter .container-box-inner {
  float: left;
  width: 100%;
}
.caixa-pesquisa .box-filter .container-box-inner label {
  float: left;
}
.caixa-pesquisa .box-filter .container-box-inner label:first-child {
  width: 100%;
}
.caixa-pesquisa .box-filter .container-box-inner > div {
  margin-bottom: 2px;
  float: left;
}
.caixa-pesquisa .box-filter .container-box-inner > div label {
  margin-right: 5px;
  color: #999999;
  background: rgba(204, 204, 204, 0.2);
  padding: 5px 10px;
  border-radius: 3px;
  transition: 0.5s;
  cursor: pointer;
}
.caixa-pesquisa .box-filter .container-box-inner > div label:hover {
  background: rgba(204, 204, 204, 0.4);
  transition: 0.5s;
}
.caixa-pesquisa .box-filter .container-box-inner:last-child {
  margin-top: 15px;
}

.modal-header {
  padding: 15px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
}
.modal-header:after {
  content: normal;
}
.modal-header h2 {
  font-weight: 100;
  text-align: center;
  margin-top: 15px;
}
.modal-header.transacao-aprovada {
  background-color: rgba(34, 183, 255, 0.25);
}
.modal-header.transacao-aprovada h2 {
  color: #22b7ff;
}
.modal-header.transacao-reprovada {
  background-color: rgba(229, 115, 115, 0.25);
}
.modal-header.transacao-reprovada h2 {
  color: #e57373;
}
.modal-header.transacao-estornada {
  background-color: rgba(204, 204, 204, 0.25);
}

.modal-body {
  margin-top: 90px;
}
.modal-body p {
  font-size: 14px;
  font-weight: 600;
}
.modal-body p.info-cartao {
  margin: 5px 0 0 -4px;
}
.modal-body p .bandeira-cartao {
  margin-top: -4px;
  margin-right: 5px;
}
.modal-body p small {
  margin-left: 5px;
  color: #999999;
  font-weight: 200;
}
.modal-body h4 {
  margin: 0;
  font-weight: 200;
  font-size: 26px;
}
.modal-body .empty {
  color: #999999;
  font-weight: 300;
  font-size: 16px;
}
.modal-body .btn-action {
  float: left;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.modal-body .btn {
  margin-top: 30px;
}
.modal-body .btn:first-child {
  margin-right: 2px;
}
.modal-body .btn:last-child {
  margin-left: 2px;
}
.modal-body .btn.loading {
  margin-right: 30px;
}
.modal-body .btn.loading::before {
  background-color: #fff;
}
.modal-body .btn-estornar {
  background-color: #e57373;
  color: #fff;
}
.modal-body .btn-default {
  border: none;
  background-color: rgba(204, 204, 204, 0.25);
}
.modal-body .btn-default:hover {
  background-color: rgba(204, 204, 204, 0.5);
}
.modal-body svg {
  width: 90px;
  height: 90px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 50px;
}

.ml-2 {
  margin-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/transacoes/transacoes.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAEA;EACI;IACI,WAAA;IACA,WAAA;IACA,8BAAA;EADN;EAEM;IACI,qBAAA;IACA,YAAA;EAAV;AACF;AAIA;EACI;IACI,WAAA;IACA,WAAA;IACA,6BAAA;EAFN;EAGM;IACI,qBAAA;IACA,YAAA;EADV;AACF;AAKA;EACI;IACI,SAAA;IACA,gBAAA;EAHN;EAKE;IACI,WAAA;EAHN;EAKE;IACI,WAAA;EAHN;AACF;AAMA;EACI,SAAA;AAJJ;;AAOA;EACI,YAAA;EACA,oCAAA;AAJJ;;AAOA;EACI,UAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAJJ;AAKI;EACI,mBAAA;AAHR;;AAOA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cC/CU;EDgDV,kBAAA;EACA,qBAAA;AAJF;AAKE;EACE,iBAAA;AAHJ;;AAOA;EACI,YAAA;AAJJ;AAMQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAJZ;AAOI;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,kCAAA;EACA,iDAAA;AALR;AAMQ;EAGI,gDAAA;AANZ;AASI;EAEI,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AARR;AAUI;EACI,UAAA;EACA,uDAAA;AARR;AAUI;EACI,WAAA;EACA,eAAA;EACA,qDAAA;AARR;AAUI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AARR;AAUI;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,sBC/GA;EDgHA,aAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AARR;AASQ;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AAPZ;AASQ;EACI,gBAAA;EACA,UAAA;AAPZ;AASQ;EACI,WAAA;EACA,WAAA;AAPZ;AAQY;EACI,WAAA;AANhB;AAOgB;EACI,WAAA;AALpB;AAQY;EACI,kBAAA;EACA,WAAA;AANhB;AAOgB;EACI,iBAAA;EACA,cClJR;EDmJQ,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AALpB;AAMoB;EACI,oCAAA;EACA,gBAAA;AAJxB;AAQY;EACI,gBAAA;AANhB;;AAYA;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AATJ;AAUI;EACI,eAAA;AARR;AAUI;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;AARR;AAUI;EACI,0CAAA;AARR;AASQ;EACI,cCjMD;AD0LX;AAUI;EACI,2CAAA;AARR;AASQ;EACE,cC7KD;ADsKT;AAUI;EACI,2CAAA;AARR;;AAYA;EACI,gBAAA;AATJ;AAUI;EACI,eAAA;EACA,gBAAA;AARR;AASQ;EACI,oBAAA;AAPZ;AASQ;EACI,gBAAA;EACA,iBAAA;AAPZ;AASQ;EACI,gBAAA;EACA,cCnNA;EDoNA,gBAAA;AAPZ;AAWI;EACI,SAAA;EACA,gBAAA;EACA,eAAA;AATR;AAYI;EACI,cC/NI;EDgOJ,gBAAA;EACA,eAAA;AAVR;AAaI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AAXR;AAcI;EACI,gBAAA;AAZR;AAaQ;EACI,iBAAA;AAXZ;AAaQ;EACI,gBAAA;AAXZ;AAaQ;EACI,kBAAA;AAXZ;AAYY;EACI,sBAAA;AAVhB;AAeI;EACI,yBAAA;EACA,WAAA;AAbR;AAgBI;EACI,YAAA;EACA,2CAAA;AAdR;AAeQ;EACI,0CAAA;AAbZ;AAgBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AAdR;;AAiBA;EACI,gBAAA;AAdJ","sourcesContent":["@import '../../../../../sass/variables';\n\n@media only screen and (min-width: 990px) {\n    .container-datepicker {\n        float: left;\n        width: 100%;\n        margin: -75px 7.5px 15px 7.5px;\n        app-datepicker {\n            margin: 20px 0 20px 0;\n            float: right;\n        }\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .container-datepicker {\n        float: left;\n        width: 100%;\n        margin: 15px 7.5px 15px 7.5px;\n        app-datepicker {\n            margin: 20px 0 20px 0;\n            float: right;\n        }\n    }\n}\n\n@media only screen and (max-width: 515px) {\n    .container-datepicker {\n        margin: 0;\n        padding: 0 7.5px;\n    }\n    app-datepicker {\n        width: 100%;\n    }\n    .btn-primary {\n        width: 100%;\n    }\n}\n\ntable {\n    margin: 0;\n}\n\napp-datepicker {\n    float: right;\n    margin-right: calc(8.333333% + 15px);\n}\n\n.hidden {\n    opacity: 0;\n}\n\n.container-loading {\n    width: 35px;\n    height: 35px;\n    margin: 0 auto;\n    .loading {\n        margin: 100px 0 0 0;\n    }\n}\n\n.error {\n  width: 100%;\n  font-size: 16px;\n  font-weight: 100;\n  color: $cinza-500;\n  text-align: center;\n  display: inline-block;\n  &:first-child {\n    margin-top: 100px;\n  }\n}\n\n.caixa-pesquisa {\n    cursor: text;\n    div {\n        input {\n            position: absolute;\n            left: 55px;\n            width: 300px;\n            max-width: calc(100% - 75px);\n            outline: none;\n            border: 0px;\n            height: 40px;\n        }\n    }\n    input.search {\n        position: relative;\n        border-radius: 6px;\n        height: 40px;\n        width: 100%;\n        margin: 0 0 20px 0;\n        border: none;\n        padding: 5px 50px;\n        outline: none;\n        transition: border-color 0.5s ease;\n        box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);\n        &:active,\n        &:hover,\n        &:focus {\n            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);\n        }\n    }\n    &::after,\n    &::before {\n        content: ' ';\n        position: absolute;\n        display: inline-block;\n        width: 24px;\n        height: 24px;\n        top: 8px;\n    }\n    &::before {\n        left: 20px;\n        background-image: url('/assets/img/icons/pesquisa.svg');\n    }\n    &::after {\n        right: 20px;\n        cursor: pointer;\n        background-image: url('/assets/img/icons/filtro.svg');\n    }\n    .filter-icon {\n        position: absolute;\n        top: 0;\n        right: 12px;\n        height: 40px;\n        width: 40px;\n        cursor: pointer;\n        z-index: 5;\n    }\n    .box-filter {\n        z-index: 5;\n        position: absolute;\n        width: 250px;\n        top: 0;\n        right: -245px;\n        background-color: $white;\n        padding: 20px;\n        border-radius: 6px;\n        box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);\n        overflow: hidden;\n        &.box-hidden {\n            transition: 0.4s;\n            opacity: 0;\n            z-index: -1;\n        }\n        &.box-show {\n            transition: 0.4s;\n            opacity: 1;\n        }\n        .container-box-inner {\n            float: left;\n            width: 100%;\n            label {\n                float: left;\n                &:first-child {\n                    width: 100%;\n                }\n            }\n            >div {\n                margin-bottom: 2px;\n                float: left;\n                label {\n                    margin-right: 5px;\n                    color: $cinza-500;\n                    background: rgba($cinza-400, 0.2);\n                    padding: 5px 10px;\n                    border-radius: 3px;\n                    transition: 0.5s;\n                    cursor: pointer;\n                    &:hover {\n                        background: rgba($cinza-400, 0.4);\n                        transition: 0.5s;\n                    }\n                }\n            }\n            &:last-child {\n                margin-top: 15px;\n            }\n        }\n    }\n}\n\n.modal-header {\n    padding: 15px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 90px;\n    &:after {\n        content: normal;\n    }\n    h2 {\n        font-weight: 100;\n        text-align: center;\n        margin-top: 15px;\n    }\n    &.transacao-aprovada {\n        background-color: rgba($azul-400, .25);\n        h2 {\n            color: $azul-400;\n        }\n    }\n    &.transacao-reprovada {\n        background-color: rgba($danger, 0.25);\n        h2 {\n          color: $danger;\n        }\n    }\n    &.transacao-estornada {\n        background-color: rgba($cinza-400, 0.25);\n    }\n}\n\n.modal-body {\n    margin-top: 90px;\n    p {\n        font-size: 14px;\n        font-weight: 600;\n        &.info-cartao {\n            margin: 5px 0 0 -4px;\n        }\n        .bandeira-cartao {\n            margin-top: -4px;\n            margin-right: 5px;\n        }\n        small {\n            margin-left: 5px;\n            color: $cinza-500;\n            font-weight: 200;\n        }\n    }\n\n    h4 {\n        margin: 0;\n        font-weight: 200;\n        font-size: 26px;\n    }\n\n    .empty {\n        color: $cinza-500;\n        font-weight: 300;\n        font-size: 16px;\n    }\n\n    .btn-action {\n        float: left;\n        position: relative;\n        left: 50%;\n        transform: translateX(-50%);\n    }\n\n    .btn {\n        margin-top: 30px;\n        &:first-child {\n            margin-right: 2px;\n        }\n        &:last-child {\n            margin-left: 2px;\n        }\n        &.loading {\n            margin-right: 30px;\n            &::before {\n                background-color: #fff;\n            }\n        }\n    }\n\n    .btn-estornar {\n        background-color: rgba($danger, 1);\n        color: #fff;\n    }\n\n    .btn-default {\n        border: none;\n        background-color: rgba($cinza-400, 0.25);\n        &:hover {\n            background-color: rgba($cinza-400, 0.5);\n        }\n    }\n    svg {\n        width: 90px;\n        height: 90px;\n        position: relative;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-bottom: 50px;\n    }\n}\n.ml-2 {\n    margin-left: 6px;\n}","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
